import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { newLayout } from 'theme';

import { StyledButton } from './TertiaryButton.styles';

const TertiaryButton = ({ children, disabled, loading, ...props }) => (
  <StyledButton {...props} disabled={disabled || loading}>
    {loading ? (
      <>
        <CircularProgress
          size={16}
          color="inherit"
          style={{ marginRight: newLayout.spacing.s2 }}
        />
        {children}
      </>
    ) : (
      children
    )}
  </StyledButton>
);

TertiaryButton.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default memo(TertiaryButton);
